import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WebHookCommonServices } from '../webhook-services/webhook-commom.services';
import { NzTableComponent, NzTableFilterValue, NzTableQueryParams, NzTableSortOrder } from 'ng-zorro-antd/table';
import { Field } from 'src/app/interfaces/field';
import { WebhookField, WebhookFieldOption } from '../webhook-interfaces/configuration';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FormServices } from 'src/app/services/form.services';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { NZ_MODAL_DATA, NzModalService } from 'ng-zorro-antd/modal';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';

interface WebhookContext {
    IDCONF: number;
    CODECOMPANY: number;
    SCHEDULE: string;
    SERVERNAME: string;
    ACTIVE:string;
    'FK_MKTPCFGCOMPANY_MKTPCOMPANIES->NAME'?:string;
    PREFERENCES: string;
    ENVIRONMENT: string;
}


@Component({
    selector: 'app-webhook-multiple-context',
    templateUrl: './webhook-multiple-context.component.html',
    styleUrl: './webhook-multiple-context.component.scss',
    standalone: false
})
export class WebhookMultipleContextComponent implements OnInit {

    loadingAddButton = false;
    loadingRemoveButton = false;
    searchCodecompany: any;
    contexts: WebhookContext[] = [];
    nextId = 1;
    editingContext: WebhookContext | null = null;
    entityName = 'Mktpcfgcompany';
    loading: boolean=false;
    total: number=1;
    editMode= false;
    pageSize = 10;
    pageIndex = 1;
    visible:{
        CODECOMPANY:boolean;
        SCHEDULE:boolean;
        SERVERNAME:boolean;
        ACTIVE:boolean;
        ENVIRONMENT:boolean;
    } = {
        CODECOMPANY: false,
        SCHEDULE: false,
        SERVERNAME: false,
        ACTIVE: false,
        ENVIRONMENT: false
    };
      

    @ViewChild('contextTable',{ static: false }) table:NzTableComponent<any>;
    currentFilter: {
        key: string;
        value: NzTableFilterValue
    }[]=[];
    filter: string;

    constructor(
        private fb: FormBuilder, 
        private whServices:WebHookCommonServices,
        private messageService:NzMessageService,
        private fs:FormServices,
        private ls:LanguageServices,
        private modal:NzModalService,
        @Inject(NZ_MODAL_DATA) public nzData
    ) {}
    contextForm: FormGroup;
    newRow:FormGroup;
    filterFormGroup:FormGroup;
    newContext = false;
    fields:WebhookField[] = [];

    environmentField:WebhookField =  {
        field:"ENVIRONMENT",
        type:"select",
        label:"environment",
        placeholder:"environment",
        options: [
            {
                "value": 1,
                "label": "workflow.environment.production"
            },
            {
                "value": 2,
                "label": "workflow.environment.homologation"
            }
        ]
    }
  
    servernameField:WebhookField = {
        field:'SERVERNAME',
        label:'servername',
        placeholder:'servername',
        type:'querySelect',
        condition:"SELECT HOSTNAME as VALUE,  NAME as LABEL FROM MKTPSERVERS WHERE ACTIVE = 'S' ORDER BY NAME",
        showKey:false
    }

    codeCompanyField:WebhookField = {
        field:'CODECOMPANY',
        label:'codecompany',
        type:'search',
        placeholder:'codecompany',
        searchProperties:{
            entityName:'Mktpcompanies',
            fields:{
                keyField:'CODECOMPANY',
                valueField:'NAME'
            }
        },
        showKey:true        
    }

    activeField:WebhookField = {
        field:'ACTIVE',
        label:'active',
        type:'select',
        placeholder:'active',
        options:[
            { value:'S', label: this.ls.instant('yes')},
            { value:'N', label: this.ls.instant('no')}
        ],
        showKey:true        
    }

    scheduleField:WebhookField = {
        field:"SCHEDULE",
        type:"text",
        label:"schedule",
        placeholder:"schedule",
        isDisabled: true,
        action: {
            component: 'CronFormComponent',
            title: this.ls.instant('workflow.schedule.title'),
            width: '80%',
            icon: 'schedule',
            okText: this.ls.instant('workflow.schedule.ok'),
            cancelText: this.ls.instant('workflow.schedule.cancel'),
            data: {
                showButtons:false,
                value: this.SCHEDULE
            },
            onOk: {eventName:null,function: (component) => {
                if (component.cronForm.value != '') {
                    this.newRow.patchValue({ SCHEDULE: component.cronForm.value });
                }
                return Promise.resolve();
            }
            },
            onCancel:{eventName:null, function: () => {
                return Promise.resolve();
                }
            }
        }
    }

    
    get IDCONF(){
        if ( this.newRow == null ){
            return '';
        }
        return this.newRow.get('IDCONF').value;
    }

    get CODECOMPANY(){
        if ( this.newRow == null ){
            return '';
        }
        return this.newRow.get('CODECOMPANY').value;
    }

    get SCHEDULE(){
        if ( this.newRow == null ){
            return '';
        }
        return this.newRow.get('SCHEDULE').value;
    }

    get ACTIVE(){
        if ( this.newRow == null ){
            return '';
        }
        return this.newRow.get('ACTIVE').value;
    }

    get ENVIRONMENT(){
        if ( this.newRow == null ){
            return '';
        }
        return this.newRow.get('ENVIRONMENT').value;
    }
    

    ngOnInit(): void {
        
        this.newRow = this.fb.group({
            IDCONF:[''],
            CODECOMPANY:['',Validators.required],
            SCHEDULE:['',Validators.required],
            SERVERNAME:['',Validators.required],
            ACTIVE:['',Validators.required],
            PREFERENCES:[null],
            ENVIRONMENT:['',Validators.required]
        });


        if ( this.nzData != null && this.nzData.editItem != null ){
            this.newRow.get("IDCONF").patchValue(this.nzData.editItem.IDCONF);
            this.newRow.get("PREFERENCES").setValue(this.nzData.editItem.PREFERENCES);
            
        }
        
        if ( this.nzData!=null && this.nzData.fields!=null){
            this.fields = this.nzData.fields;
        }
        
        this.currentFilter.push({key:'this.IDCONF', value:[this.IDCONF]});
        this.loadDataFromServer(this.pageIndex, this.pageSize, null, null, this.currentFilter);

      
        this.filterFormGroup = this.fb.group({
            CODECOMPANY:[''],
            SERVERNAME:[''],
            ACTIVE:[''],
            ENVIRONMENT:['']
        });

        this.contextForm = this.fb.group({
            CODECOMPANY: ['', Validators.required],
            SCHEDULE: ['', Validators.required],
            SERVERNAME: ['', Validators.required],
            ENVIRONMENT:['', Validators.required]
        });

        this.newRow.valueChanges.subscribe(d=>{
            this.editingContext = d;
        });
    }

    

    insertContext(): void {
        
        this.whServices.createGeneric(this.newRow, this.entityName).then(data=>{

            const context: WebhookContext = {
                IDCONF: data['IDCONF'],
                CODECOMPANY: data['CODECOMPANY'],
                SCHEDULE: data['SCHEDULE'],
                SERVERNAME: data['SERVERNAME'],
                ACTIVE: data['ACTIVE'],
                PREFERENCES: data['PREFERENCES'],
                ENVIRONMENT: data['ENVIRONMENT']

            };
            if ( this.editingContext != null ){
                let index = this.contexts.findIndex(d=>d.IDCONF == data['IDCONF']);
                this.contexts[index] = context;
            }else{
                this.contexts = [...this.contexts,context];
            }
            
            this.clearRow();
            this.editMode = false;
            this.loadingAddButton = false;
        }).catch(erro=>{
            this.messageService.error(GlobalErrorHandler.getMessage(erro));
            this.loadingAddButton = false;
        });
        
      
        
    }

    editContext(context: WebhookContext): void {
        this.editingContext = context;
        this.editMode = true;
        this.fs.patchForm(context,this.newRow);
        this.newRow.get("CODECOMPANY").disable();
        
    }

    getActiveDesc(value:string): string {
        return this.ls.instant(
            (this.activeField.options.find(d=>{
                let option:WebhookFieldOption = d as WebhookFieldOption;
                if ( option.value == value){
                    return option;
                }else{
                    return null;
                }
            }) as WebhookFieldOption)?.label);
    }

    getEnvironmentDesc(value:string): string {
        if ( value == null ||  value == '' ){
            return '';
        }
        return this.ls.instant(
            (this.environmentField.options.find(d=>{
                let option:WebhookFieldOption = d as WebhookFieldOption;
                if ( option.value == value){
                    return option;
                }else{
                    return null;
                }
            }) as WebhookFieldOption)?.label);
    }

    deleteContext(context: WebhookContext): void {

        this.modal.confirm({
            nzTitle: this.ls.instant('context.remove.title'),
            nzContent: this.ls.instant('context.remove.question'),
            nzOkText: this.ls.instant('confirm'),
            nzOkDanger: true,
            nzCancelText: this.ls.instant('cancel'),
            nzOnOk: () => {
                let condition = `IDCONF = ${context.IDCONF} AND CODECOMPANY = ${context.CODECOMPANY}`;
                this.loadingRemoveButton = true;
                this.whServices.removeGeneric(condition,this.entityName).then(d=>{
                    this.contexts = this.contexts.filter(v => v.IDCONF == context.IDCONF && v.CODECOMPANY != context.CODECOMPANY     );
                    this.loadingRemoveButton = false;
                }).catch(erro=>{
                    this.loadingRemoveButton = false;
                    this.messageService.error(GlobalErrorHandler.getMessage(erro));
                });
            }
        });
        
    }

    editContextDoubleClick(event){
        this.editContext(event);
    }

    cancelEdit(): void {
        this.editingContext = null;
    }

    
    loadDataFromServer(
        pageIndex: number,
        pageSize: number,
        sortField: string | null,
        sortOrder: string | null,
        filter: Array<{ key: string; value: string[] }>
        ): void {
            this.loading = true;
            this.whServices.findGeneric(((pageIndex-1)*pageSize), pageSize, sortField, sortOrder, filter, this.entityName).then(data => {
                this.loading = false;
                this.total = data['totalLines']; // mock the total data here
                this.contexts = data[this.entityName] || [];
            }, error => {
                this.loading = false;   
                this.messageService.error(GlobalErrorHandler.getMessage(error));
            });
    }

     onQueryParamsChange(params: NzTableQueryParams): void {
        
        let { pageSize, pageIndex, sort, filter } = params;
        
        if ( this.currentFilter.length > 0 ){
            filter = this.currentFilter;
        }

        const currentSort = sort.find(item => item.value !== null);
        const sortField = (currentSort && currentSort.key) || null;
        const sortOrder = (currentSort && currentSort.value) || null;
        this.loadDataFromServer(pageIndex, pageSize, sortField, sortOrder, filter);
        
        if ( sort.length > 0 ){
            this.sortField(sort);
        }
    }
    
    sortField(sort: {key:string,value:NzTableSortOrder}[]) {
       for (var item of sort ){
        if ( item.value != null ){
            
            this.contexts.sort((a, b) => {
            if (typeof a[item.key] === 'string' && typeof b[item.key] === 'string') {
                
                    if ( a["NAME"] > b["NAME"] ) {
                        return 1 * (item.value == 'ascend' ? 1 : -1);
                    }
                    if ( a["NAME"] < b["NAME"] ) {
                        return -1 * (item.value == 'ascend' ? 1 : -1);
                    }
                    return 0;


                } else {
                return item.value === 'ascend'
                    ? Number(a[item.key]) - Number(b[item.key])
                    : Number(b[item.key]) - Number(a[item.key]);
                }

            
            });
        }
       }
    }

    search(field: string) {
        let index = this.currentFilter.findIndex(d=>d.key=="this."+field);

        if  ( index == -1 ){
            this.currentFilter.push({
            key:"this."+field,
            value:this.filterFormGroup.get(field).value
            })
        }else{
            this.currentFilter.find(d=>d.key=="this."+field).value = this.filterFormGroup.get(field).value;
        }
        
        let param:NzTableQueryParams = { 
            pageSize:this.table.nzPageSize,
            pageIndex: this.table.nzPageIndex,
            sort: [],
            filter: this.currentFilter
        }
        this.table.nzQueryParams.emit(param);
        
        this.visible[field] = false;
        
    }

    reset(field: string) {
        this.filterFormGroup.get(field).setValue('');
        let index = this.currentFilter.findIndex(d=>d.key=="this."+field);
        this.currentFilter.splice(index,1);
        this.search(field);
    }

   addRow(){
        
        if ( this.newRow.invalid){
            this.whServices.showError(this.fields,this.newRow);
            return;
        }else{
            this.loadingAddButton = true;
            this.insertContext();
        }
   }

   clearRow(){
        this.newRow.reset();
        this.newRow.get("IDCONF").setValue(this.nzData.editItem.IDCONF);
        this.newRow.get("PREFERENCES").setValue(this.nzData.editItem.PREFERENCES);
        this.editingContext = null;
        this.newContext = false;
   }

}